<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>老客专享M9</span>
                </div>
            </div>
            <div class="search_box">
                <el-form :inline="true" :model="searchData" class="demo-form-inline search-form form-list">
                    <el-form-item label="订单号" class="form_item">
                        <el-input placeholder="请输入" clearable v-model="searchData.order_id"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" class="form_item">
                        <el-input placeholder="请输入" clearable v-model="searchData.mail"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>
                        <div class="button search" @click="openAddDialog" v-if="roleCheck('105-104-101-102')">
                            <span>手动添加</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <el-table
                highlight-current-row
                :data="listData">
                <el-table-column prop="order_id" label="订单号" min-width="140"></el-table-column>
                <el-table-column prop="buyer_email" label="买家邮箱" min-width="180"></el-table-column>
                <el-table-column prop="discount_code" label="折扣码" min-width="150"></el-table-column>
                <el-table-column prop="valid_text" label="有效期" min-width="180"></el-table-column>
                <el-table-column label="来源" width="100">
                    <template slot-scope="scope">
                        <span>{{ sourceMap[scope.row.source] || scope.row.source }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="operator" label="操作人" min-width="100"></el-table-column>
                <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column label="创建时间" min-width="160">
                    <template slot-scope="scope">
                        <span>{{ scope.row.created_at }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
        </div>
        <Gh-Dialog ref="addDialog" title="手动添加" @dialogBack="addConfirm">
            <template v-slot:content>
                <el-form label-width="90px" :model="addData" :rules="addRules" ref="addForm">
                    <el-form-item label="邮箱" prop="mail">
                        <el-input v-model="addData.mail" placeholder="请输入买家邮箱"></el-input>
                    </el-form-item>
                    <el-form-item label="订单号" prop="order_id">
                        <el-input v-model="addData.order_id" placeholder="请输入订单号"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark">
                        <el-input type="textarea" :rows="3" v-model="addData.remark" placeholder="选填"></el-input>
                    </el-form-item>
                </el-form>
            </template>
        </Gh-Dialog>
    </div>
</template>
<script>
export default({
    name: 'm9-presale',
    data() {
        return {
            searchData: {
                order_id: '',
                mail: '',
                page: 1,
                page_size: 10
            },
            listData: [],
            total: 0,
            sourceMap: {
                1: '系统生成',
                2: '手动添加'
            },
            addData: {
                mail: '',
                order_id: '',
                remark: ''
            },
            addRules: {
                mail: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' }
                ],
                order_id: [
                    { required: true, message: '请输入订单号', trigger: 'blur' }
                ]
            }
        }
    },
    activated() {
        this.getList();
    },
    methods: {
        search() {
            this.searchData.page = 1;
            this.getList();
        },
        getList() {
            this.api.getM9PresaleList(this.searchData).then(data => {
                this.listData = data.data.list;
                this.total = data.data.total;
            })
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getList();
        },
        openAddDialog() {
            this.addData = { mail: '', order_id: '', remark: '' };
            this.$refs.addDialog.show = true;
        },
        addConfirm() {
            this.$refs.addForm.validate(valid => {
                if (!valid) return;
                this.api.addM9PresaleManual(this.addData).then(() => {
                    this.$refs.addDialog.show = false;
                    this.searchData.page = 1;
                    this.getList();
                });
            });
        }
    }
})
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/view/product/m9/presale.vue